import React, { useState } from "react";
import classes from "./LoginScreen.module.css";
import SigninScreen from "../SigninScreen/SigninScreen";
const LoginScreen = () => {
  const [signIn, setSignIn] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const handleSignin = (e) => {
    e.preventDefault();
    setSignIn(true);
  };

  return (
    <div className={classes.loginscreen}>
      <div className={classes.loginscreen_background}>
        <img
          className={classes.loginscreen_logo}
          src="https://1000logos.net/wp-content/uploads/2017/05/Netflix-Logo.png"
          alt="netflix logo"
        />
        <button onClick={handleSignin} className={classes.loginscreen_button}>
          Sign in
        </button>
        <div className={classes.loginscreen_gradient} />
      </div>
      <div className={classes.loginscreen_body}>
        {signIn ? (
          <SigninScreen userEmail={userEmail} />
        ) : (
          <>
            <h1>Unlimited films,Tv programs and more.</h1>
            <h2>Watch anywhere. Cancel at any time</h2>
            <h3>
              Ready to watch Enter your email to create or restart your
              membership
            </h3>
            <div className={classes.loginscreen_input}>
              <form>
                <input
                  type="email"
                  placeholder=" Email Address"
                  value={userEmail}
                  onChange={(event) => setUserEmail(event.target.value)}
                />
                <button
                  onClick={handleSignin}
                  className={classes.loginscreen_getstarted}
                >
                  GET STARTED
                </button>
              </form>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default LoginScreen;
